import { request } from '@helpers/fetch';
import { Response } from '@models/response';
import { ExamInvitationResponse } from '@models/syncVisit';

export const apiSyncVisit = {
  isQualifyAvailable(): Promise<Response<{ available: boolean }>> {
    return request.get('/api/v1/sync-visits/is-qualiphy-available');
  },
  getInvitationData(payload: {
    treatmentId: number | null,
    patientId: number,
    submissionId: number | null,
    sendEmail: boolean,
    attempt?: number,
  }): Promise<Response<ExamInvitationResponse>> {
    return request.post('/api/v1/sync-visits/invite', payload);
  },
};
